import { render } from "./RemoveCredForm.vue?vue&type=template&id=442272e4&scoped=true"
import script from "./RemoveCredForm.vue?vue&type=script&lang=js"
export * from "./RemoveCredForm.vue?vue&type=script&lang=js"

import "./RemoveCredForm.vue?vue&type=style&index=0&id=442272e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442272e4"]])

export default __exports__